import { ApplicationName, AppState } from "@/lib/types";
import { useMethodActions } from "@/store/MethodStore";
import DraggableWindow from "./DraggableWindow";
import ContextContainer from "../ContextContainer";
import AppIcon from "./AppIcon";
import useApps from "@/hooks/useApps";
import { BsPinAngleFill } from "react-icons/bs";
import { MdOpenInNew } from "react-icons/md";
import { ContextMenuItem } from "../ui/context-menu";
import useDockStore from "@/store/dockStore";
import useShortcuts from "@/hooks/useShortcuts";
import { RiUnpinFill } from "react-icons/ri";

function DesktopApps() {

  const addPinnedApp = useDockStore(state => state.addPinnedApp)
  const removePinnedApp = useDockStore(state => state.removePinnedApp)
  const {
    setFocusedWindow,
    setShowBSOD,
  } = useMethodActions();

  const pinnedApps = useDockStore(state => state.pinnedApps)

  const toggleAppState = (appName: ApplicationName, stateSetter: (state: AppState) => void) => {
    stateSetter("floating");
    setFocusedWindow(appName);
    if (Math.random() < 1 / 15) {
      setShowBSOD(true)
    }
  };

  const isMediumScreen = window.matchMedia("(max-width: 768px)").matches

  const apps = useApps()
  const shortcuts = useShortcuts()

  return (
    <>
      {apps.map(({ name, component, state, setState, icon, hasFullScreen, enableDrag }) => (
        <DraggableWindow
          key={name}
          isOpen={state}
          enableDragOn={enableDrag}
          setIsOpen={setState}
          hasFullScreen={hasFullScreen}
          trigger={
            <ContextContainer trigger={
              <AppIcon onClickHandler={() => toggleAppState(name, setState)} icon={icon} name={name} />
            }>
              <ContextMenuItem onClick={() => toggleAppState(name, setState)}>
                <MdOpenInNew className="text-lg" />
                <span className="ml-3">Open</span>
              </ContextMenuItem>
              {!isMediumScreen && (!pinnedApps.includes(name)
                ? <ContextMenuItem onClick={() => addPinnedApp(name)}>
                  <BsPinAngleFill className="text-lg" />
                  <span className="ml-3">Pin to dock</span>
                </ContextMenuItem>
                : <ContextMenuItem onClick={() => removePinnedApp(name)}>
                  <RiUnpinFill className="text-lg" />
                  <span className="ml-3">Unpin</span>
                </ContextMenuItem>)
              }
            </ContextContainer>
          }
          applicationName={name}
        >
          {component}
        </DraggableWindow>
      ))}
      {shortcuts.map(({ icon, name, onClickHandler, contextMenu }) => (
        <ContextContainer key={name} trigger={
          <AppIcon onClickHandler={onClickHandler} icon={icon} name={name} />
        }>
          {contextMenu.map(({ icon, name, onClickHandler }) => (
            <ContextMenuItem key={name} onClick={onClickHandler}>
              {icon}
              <span className="ml-3">{name}</span>
            </ContextMenuItem>
          ))}
          {!isMediumScreen && (!pinnedApps.includes(name)
            ? <ContextMenuItem onClick={() => addPinnedApp(name)}>
              <BsPinAngleFill className="text-lg" />
              <span className="ml-3">Pin to dock</span>
            </ContextMenuItem>
            : <ContextMenuItem onClick={() => removePinnedApp(name)}>
              <RiUnpinFill className="text-lg" />
              <span className="ml-3">Unpin</span>
            </ContextMenuItem>)
          }
        </ContextContainer>
      ))}
    </>
  )
}

export default DesktopApps